// extracted by mini-css-extract-plugin
module.exports = {"loader":"LoadingSpinner_loader__1Wqqz","spin":"LoadingSpinner_spin__265o_"};